module.exports = __webpack_public_path__ + "img/1.3f3475a0.jpg";